export default __webpack_public_path__ + "static/media/element_79.ab968922.avif";